import React from 'react';
import PropTypes from 'prop-types';
import { IconUrgency, Span } from '@febos-io/design';
import useTranslation from '../hooks/useTranslation';

export function ModalExamTitle({ exam }) {
  const { t } = useTranslation();

  if (!exam) {
    return null;
  }
  return (
    <div className="row border-bottom pb-1">
      <div className="col-9">
        <IconUrgency
          urgency={exam.urgency}
          icon="flag"
          className="me-1"
        />
        <strong className="text-uppercase text-primary me-1">
          {t(exam.name)}
        </strong>
      </div>
      <div className="col-3 text-end">
        <Span title={t('Exam Number')} className="badge bg-primary text-white fs-6">
          {exam.number}
        </Span>
      </div>
    </div>
  );
}

ModalExamTitle.propTypes = {
  exam: PropTypes.oneOfType([PropTypes.object])
};

export default ModalExamTitle;
